import React from 'react';
import * as _ from 'lodash';
import * as styles from './BucketBlock.scss';

var seedRandom = function seedRandom(seed) {
  var s = Math.sin(seed) * 10000;
  return s - Math.floor(s);
};

function BucketBlock(props) {
  var data = props.data,
      onClick = props.onClick;

  var hexToRgb = function hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? "".concat(parseInt(result[1], 16), ",").concat(parseInt(result[2], 16), ",").concat(parseInt(result[3], 16)) : null;
  };

  var titlePositions = window.innerWidth < 1650 ? [20, 60, 100] : [24, 75, 130];
  var tagPosition = titlePositions[Math.floor(seedRandom(parseInt(data.id, 10)) * titlePositions.length)]; // TODO handle resize position of title backgrounds when going from big to small

  return /*#__PURE__*/React.createElement("div", {
    className: styles.wrap,
    onClick: onClick
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.imageWrap,
    style: {
      backgroundImage: "linear-gradient(rgba(".concat(hexToRgb(data.avatarImageColor), ", 0.3), rgba(").concat(hexToRgb(data.avatarImageColor), ", 0.15) ), url(").concat(data.avatarImageUrl, ")")
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.titleWrap,
    style: {
      backgroundColor: "rgba(".concat(hexToRgb(data.avatarImageColor), ", 0.9)"),
      top: tagPosition
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, data.name)));
}

export default BucketBlock;